import { useStripe } from "@stripe/react-stripe-js";
import { useCallback } from "react";
import { useConfirmPaymentMutation } from "../queries/Payment.generated";

type CreateTokenParams = {
  accountNumber: string;
  currency: string;
  type: string;
  country: string;
};

export const useConfirmPayment = () => {
  const stripe = useStripe();
  const [confirmPayment] = useConfirmPaymentMutation();

  const handleConfirmPayment = useCallback(
    async (clientSecret: string, paymentId: string, captureSentryException: ToDo) => {
      const confirmStripePayment = await stripe?.confirmCardPayment(clientSecret);
      if (confirmStripePayment?.error) {
        captureSentryException("[Stripe confirm payment error]", {
          extra: {
            errorMessage: confirmStripePayment?.error,
          },
        });
        return false;
      }

      const { errors } = await confirmPayment({
        variables: {
          paymentId,
        },
      });

      if (errors) {
        captureSentryException("[Confirm payment error]", {
          extra: { errorMessage: errors[0]?.message },
        });
        return false;
      }

      return true;
    },
    [stripe, confirmPayment],
  );

  return handleConfirmPayment;
};

export const useCreateBankAccountToken = () => {
  const stripe = useStripe();
  const createBankAccountToken = useCallback(
    async ({ accountNumber, ...rest }: CreateTokenParams) => {
      // @ts-expect-error
      const { token } = await stripe.createToken("bank_account", {
        ...rest,
        bank_account: { account_number: accountNumber },
      });

      const parsedToken = {
        bankAccount: {
          bankName: token?.bank_account?.bank_name,
          ...token?.bank_account,
        },
        ...token,
      };

      return parsedToken;
    },
    [stripe],
  );

  return [createBankAccountToken] as const;
};
